import { render, staticRenderFns } from "./RecentStudentStudyPanel.vue?vue&type=template&id=1143ae4f&scoped=true"
import script from "./RecentStudentStudyPanel.vue?vue&type=script&lang=js"
export * from "./RecentStudentStudyPanel.vue?vue&type=script&lang=js"
import style0 from "./RecentStudentStudyPanel.vue?vue&type=style&index=0&id=1143ae4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1143ae4f",
  null
  
)

export default component.exports